import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "menu-open-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M12.2686 11.9998C12.2686 11.5855 12.6043 11.2498 13.0186 11.2498L21.0006 11.2498C21.4149 11.2498 21.7506 11.5855 21.7506 11.9998C21.7506 12.414 21.4149 12.7498 21.0006 12.7498L13.0186 12.7498C12.6043 12.7498 12.2686 12.414 12.2686 11.9998Z"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M8.25293 17.9978C8.25293 17.5836 8.58872 17.2478 9.00293 17.2478L21.0004 17.2478C21.4146 17.2478 21.7504 17.5836 21.7504 17.9978C21.7504 18.412 21.4146 18.7478 21.0004 18.7478L9.00293 18.7478C8.58872 18.7478 8.25293 18.412 8.25293 17.9978Z"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M8.25293 6.0022C8.25293 5.58798 8.58872 5.2522 9.00293 5.2522L21.0004 5.2522C21.4146 5.2522 21.7504 5.58798 21.7504 6.0022C21.7504 6.41641 21.4146 6.7522 21.0004 6.7522L9.00293 6.7522C8.58872 6.7522 8.25293 6.41641 8.25293 6.0022Z"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M2.46967 6.50361C2.76256 6.21071 3.23744 6.21071 3.53033 6.50361L8.49624 11.4695C8.78914 11.7624 8.78914 12.2373 8.49624 12.5302L3.53033 17.4961C3.23744 17.789 2.76256 17.789 2.46967 17.4961C2.17678 17.2032 2.17678 16.7283 2.46967 16.4354L6.90525 11.9998L2.46967 7.56427C2.17678 7.27137 2.17678 6.7965 2.46967 6.50361Z"
    }, null, -1)
  ])))
}
export default { render: render }